import React from "react";
import TicketMasterApolloClient, {
  type TicketMasterApolloClientProps,
} from "../../TicketMasterApolloClient/TicketMasterApolloClient.js";
import InternalManualTicketForm from "./InternalManualTicketForm.js";

// `filters_config` is forwarded verbatim to the (still-untyped) child form and
// down into the GraphQL `FiltersConfigInput`. This is the superset of fields
// the app consumer (CreateTicket.tsx) passes; kept loose because this wrapper
// never introspects it.
export interface InternalManualTicketFiltersConfig {
  filtersjson?: string;
  scopesjson?: string;
  scopesid?: string | null;
}

export interface InternalManualTicketProps {
  apolloClient?: TicketMasterApolloClientProps["apolloClient"] | null;
  closeModal: () => void;
  filters_config?: InternalManualTicketFiltersConfig;
  onError?: (error: { message: string }) => void;
  onSuccess?: (ticket: unknown) => void;
  fieldMappingId?: string;
  ticketManagerFriendlyName?: string;
  ticketManagerId?: string;
  ticketManagerMustHaveMapping?: boolean;
  ticketManagerMustHaveColumnsMapping?: boolean;
  // Provider props are passed straight through to the untyped child form; the
  // app consumer types them as `unknown`, so we preserve that here.
  ticketManagerProviders?: unknown;
  ticketProviderId?: string;
  keys?: unknown;
  wrapperClassName?: string;
  onCreateMapping?: () => void;
  onCreateMappingError?: () => void;
  onEventTriggered?: (...args: unknown[]) => void;
  rmqId?: string;
}

const InternalManualTicket: React.FC<InternalManualTicketProps> = ({
  apolloClient = null,
  closeModal,
  filters_config,
  onError = () => {},
  onSuccess = () => {},
  fieldMappingId,
  ticketManagerFriendlyName,
  ticketManagerId,
  ticketManagerMustHaveMapping,
  ticketManagerMustHaveColumnsMapping,
  ticketManagerProviders,
  ticketProviderId,
  keys,
  wrapperClassName = "",
  onCreateMapping = () => {},
  onCreateMappingError = () => {},
  onEventTriggered = () => {},
  rmqId,
}) => {
  return !!apolloClient ? (
    <TicketMasterApolloClient apolloClient={apolloClient}>
      <InternalManualTicketForm
        filters_config={filters_config}
        closeModal={closeModal}
        onError={onError}
        onSuccess={onSuccess}
        fieldMappingId={fieldMappingId}
        ticketManagerFriendlyName={ticketManagerFriendlyName}
        ticketManagerId={ticketManagerId}
        ticketManagerMustHaveMapping={ticketManagerMustHaveMapping}
        ticketManagerMustHaveColumnsMapping={
          ticketManagerMustHaveColumnsMapping
        }
        ticketManagerProviders={ticketManagerProviders}
        ticketProviderId={ticketProviderId}
        keys={keys}
        wrapperClassName={wrapperClassName}
        onCreateMapping={onCreateMapping}
        onCreateMappingError={onCreateMappingError}
        onEventTriggered={onEventTriggered}
        rmqId={rmqId}
      />
    </TicketMasterApolloClient>
  ) : (
    <div>Error loading Manual ticket form</div>
  );
};

export default InternalManualTicket;
